// mutationsはここでまとめる

export const SAMPLE = {
  INCREASE: 'SAMPLE__INCREASE',
  DECREASE: 'SAMPLE__DECREASE',
  API_SUCCESS: 'SAMPLE__API_SUCCESS',
  API_FAILED: 'SAMPLE__API_FAILED',
  INIT_DATA: 'SAMPLE__INIT_DATA'
}
export const ACTION = {
  ACTION_LIST: 'ACTION__ACTION_LIST',
  ACTION_CREATE: 'ACTION__ACTION_CREATE',
  ACTION_UPDATE: 'ACTION__ACTION_UPDATE',
  ACTION_GET: 'ACTION__ACTION_GET',
  SCENARIO_LIST: 'ACTION__SCENARIO_LIST',
  MODEL: 'ACTION__MODEL',
  UPLOAD_IMAGE: 'ACTION__UPLOAD_IMAGE'
}
export const DOMAIN = {
  DOMAIN_LIST: 'DOMAIN__DOMAIN_LIST',
  DOMAIN_CREATE: 'DOMAIN__DOMAIN_CREATE',
  DOMAIN_UPDATE: 'DOMAIN__DOMAIN_UPDATE',
  DOMAIN_GET: 'DOMAIN__DOMAIN_GET'
}
export const FRAME = {
  FRAME_LIST: 'FRAME__FRAME_LIST',
  FRAME_CREATE: 'FRAME__FRAME_CREATE',
  FRAME_UPDATE: 'FRAME__FRAME_UPDATE',
  FRAME_GET: 'FRAME__FRAME_GET',
  ACTION_GET: 'FRAME__ACTION_GET',
  ACTION_LIST: 'FRAME__ACTION_LIST',
  DOMAIN_LIST: 'FRAME__DOMAIN_LIST',
  RATIO_CHANGE: 'FRAME__RATIO_CHANGE',
  ACTION_TYPE: 'FRAME__ACTION_TYPE',
  SEGMENT_LIST: 'FRAME__SEGMENT_LIST'
}

export const DECISIONTREE = {
  DATASOURCE_LIST: 'DECISIONTREE__DATASOURCE_LIST',
  DECISIONTREE_LIST: 'DECISIONTREE__DECISIONTREE_LIST',
  DECISIONTREE_CREATE: 'DECISIONTREE__DECISIONTREE_CREATE',
  DECISIONTREE_UPDATE: 'DECISIONTREE__DECISIONTREE_UPDATE',
  DECISIONTREE_GET: 'DECISIONTREE__DECISIONTREE_GET'
}

export const SIGNIN = {
  SIGNOUT: 'SIGNIN__SIGNOUT',
  SIGNIN: 'SIGNIN__SIGNIN'
}

export const ACCOUNT = {
  ACCOUNT_ID: 'ACCOUNT__ACCOUNT_ID'
}



// WEBPACK FOOTER //
// ./src/mutations/index.js